var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E5A240",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.49 10 10 14.49 10 20C10 25.51 14.49 30 20 30C25.51 30 30 25.51 30 20C30 14.49 25.51 10 20 10ZM24.35 23.57C24.21 23.81 23.96 23.94 23.7 23.94C23.57 23.94 23.44 23.91 23.32 23.83L20.22 21.98C19.45 21.52 18.88 20.51 18.88 19.62V15.52C18.88 15.11 19.22 14.77 19.63 14.77C20.04 14.77 20.38 15.11 20.38 15.52V19.62C20.38 19.98 20.68 20.51 20.99 20.69L24.09 22.54C24.45 22.75 24.57 23.21 24.35 23.57Z",
    fill: "#E5A240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.87706e191d5e44fc9c7800dd90cacb1d.svg";
export { ForwardRef as ReactComponent };